/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {connect, ConnectedProps} from 'react-redux';
import {IReduxStoreState} from '@src/@interfaces';
import {setDarkTheme, setLightTheme, toggleTheme} from '@src/_redux/theme/actions';
import classnames from '@src/helpers/classnames';

interface IDarkThemeSwitcherProps<
        E extends HTMLElement = HTMLElement
> extends ConnectedProps<typeof connector>, React.HTMLAttributes<E> {
    tag?: string | React.ComponentType<React.HTMLProps<HTMLElement>>,
    wrapperTag?: string | React.ComponentType<React.HTMLProps<HTMLElement>>,
    wrapperClassName?: string,
}

export class DarkThemeSwitcher<E extends HTMLElement = HTMLElement> extends React.Component<IDarkThemeSwitcherProps<E>> {
    constructor(props: IDarkThemeSwitcherProps<E>) {
        super(props);

        this.toggleTheme = this.toggleTheme.bind(this);
    }

    render() {
        const {
            tag: Tag = 'button',
            wrapperTag: Wrapper = 'div',
            wrapperClassName,
            theme,
            locale,
            toggleTheme,
            setDarkTheme,
            setLightTheme,
            ...rest
        } = this.props;

        return <Wrapper className={wrapperClassName} onClick={this.toggleTheme}>
            <Tag
                    {...rest}
                    className={classnames(rest.className, 'dark-theme-switcher', {
                        'dark-theme-switcher--active': theme.dark,
                    })}
            >
                <div className="dark-theme-switcher__wrapper">
                    <div className="dark-theme-switcher__left-side">
                        <span><i className="fas fa-moon"/></span>
                    </div>

                    <div className="dark-theme-switcher__toggler"/>

                    <div className="dark-theme-switcher__right-side">
                        <span><i className="fas fa-sun"/></span>
                    </div>
                </div>
            </Tag>
        </Wrapper>;
    }

    protected toggleTheme() {
        this.props.toggleTheme();
    }
}

export const connector = connect(
        (state: IReduxStoreState) => ({
            locale: state.locale.locale,
            theme: state.theme,
        }),
        {toggleTheme, setLightTheme, setDarkTheme}
);

export default connector(DarkThemeSwitcher);
